import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidaCpfService implements Validator {

  static cpfLength = 11;

  /**
   * Calcula o dígito verificador do CPF.
   */
  static buildDigit(arr: number[]): number {

    const isCpf = arr.length < ValidaCpfService.cpfLength;
    const digit = arr
      .map((val, idx) => val * ((!isCpf ? idx % 8 : idx) + 2))
      .reduce((total, current) => total + current) % ValidaCpfService.cpfLength;

    if (digit < 2 && isCpf) { return 0; } else if (digit < 2) { return 0; }

    return ValidaCpfService.cpfLength - digit;
  }

  /**
   * Valida um CPF de acordo com seu dígito verificador.
   */
  static validate(c: AbstractControl): ValidationErrors | null {

    const cpf = c.value.replace(/\D/g, '');

    // Verifica o tamanho da string.
    if ([ValidaCpfService.cpfLength].indexOf(cpf.length) < 0) {
      return { length: true };
    }

    // Verifica se todos os dígitos são iguais.
    if (/^([0-9])\1*$/.test(cpf)) {
      return { equalDigits: true };
    }

    // A seguir é realizado o cálculo verificador.
    const cpfArr: number[] = cpf.split('').reverse().slice(2);

    cpfArr.unshift(ValidaCpfService.buildDigit(cpfArr));
    cpfArr.unshift(ValidaCpfService.buildDigit(cpfArr));

    if (cpf !== cpfArr.reverse().join('')) {
      // Dígito verificador não é válido, resultando em falha.
      return { digit: true };
    }

    return null;
  }

  /**
   * Implementa a interface de um validator.
   */
  validate(c: AbstractControl): ValidationErrors | null {
    return ValidaCpfService.validate(c);
  }
}
